/**
 * FollowupMetricsCards — 24h aggregate cards for the Follow-ups page
 * (Story 7.14 AC2).
 */

import { useQuery } from '@tanstack/react-query';

import { Card, CardContent } from '@/components/ui/card';
import { apiClient } from '@/lib/api';

interface Aggregate {
  sent: number;
  failed: number;
  skipped_window: number;
  skipped_opted_out: number;
  skipped_24h_gate: number;
}

const CARD_DEFS: Array<{ key: keyof Aggregate; label: string; accent: string }> = [
  { key: 'sent', label: 'Enviados', accent: 'text-green-700 dark:text-green-300' },
  { key: 'failed', label: 'Falhas', accent: 'text-red-700 dark:text-red-300' },
  {
    key: 'skipped_window',
    label: 'Skipped (janela)',
    accent: 'text-amber-700 dark:text-amber-300',
  },
  {
    key: 'skipped_opted_out',
    label: 'Skipped (opt-out)',
    accent: 'text-muted-foreground',
  },
  {
    key: 'skipped_24h_gate',
    label: 'Skipped (24h)',
    accent: 'text-orange-700 dark:text-orange-300',
  },
];

export function FollowupMetricsCards() {
  const query = useQuery({
    queryKey: ['followups', 'aggregate', '24h'],
    queryFn: () => apiClient.get<Aggregate>('/admin/followups/aggregate/24h'),
    refetchInterval: 30_000,
  });

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
      {CARD_DEFS.map((def) => (
        <Card key={def.key}>
          <CardContent className="p-4">
            <div className="text-xs text-muted-foreground">{def.label}</div>
            <div className={`mt-1 text-2xl font-semibold ${def.accent}`}>
              {query.isLoading ? '—' : (query.data?.[def.key] ?? 0)}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">últimas 24h</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
